import { useEffect } from 'react'

interface ClickOutsideHandlerProps {
  ref: React.RefObject<HTMLElement>
  handler: () => void
  // Elementy renderowane w portalu, które też liczą się jako „wewnątrz".
  ignoreRefs?: React.RefObject<HTMLElement>[]
}

export const useClickOutside = ({ ref, handler, ignoreRefs }: ClickOutsideHandlerProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (ignoreRefs?.some((r) => r.current?.contains(target))) return
      if (ref.current && !ref.current.contains(target)) {
        handler()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, handler, ignoreRefs])
}
